var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1744.376,
    height: 219.548,
    viewBox: "0 0 1744.376 205.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M986.936,639.736c86.189-134.893-205.281-112.558-434.791-92.918-310.365,26.559-403.554,89.051-497.074,71-182.964-35.32-512.108-46.539-615.729,21.918v91.823a20,20,0,0,0,20,20H1165.072a19.99,19.99,0,0,0,18.645-12.807C1114.147,711.466,942.554,709.188,986.936,639.736Z",
    transform: "translate(560.659 -532.011)",
    fill: "#efeffa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleWave);
export default __webpack_public_path__ + "static/media/purpleWave.d00c96c4e7cff2d950885cb1f8e65e6b.svg";
export { ForwardRef as ReactComponent };